import { NgModule } from '@angular/core'
import { GaugeChartComponent } from './gauge-chart.component'

@NgModule({
  imports: [],
  declarations: [GaugeChartComponent],
  exports: [GaugeChartComponent],
})
export class GaugeChartModule {}
